import * as React from "react"
import { useEffect, useState } from "react";
import { loadGoogleAnalytics } from "../utils/loadGoogleAnalytics";
import { loadClarity } from "../utils/loadClarity";

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [consent, setConsent] = useState({
    necessary: true,
    analytics: true,
    clarity: true,
  });

  useEffect(() => {
    const storedConsent = JSON.parse(localStorage.getItem("cookieConsent"));
    if (storedConsent) {
      setConsent(storedConsent);
      if (storedConsent.analytics) {
        loadGoogleAnalytics();
      }
      if (storedConsent.clarity) {
        loadClarity();
      }
    } else {
      setIsVisible(true);
    }
  }, []);

  const handleConsent = () => {
    localStorage.setItem("cookieConsent", JSON.stringify(consent));
    setIsVisible(false);

    if (consent.analytics) {
      loadGoogleAnalytics();
    }

    if (consent.clarity) {
      loadClarity();
    }
  };

  const handleDecline = () => {
    const declinedConsent = { necessary: true, analytics: false, clarity: false};
    localStorage.setItem("cookieConsent", JSON.stringify(declinedConsent));
    setConsent(declinedConsent);
    setIsVisible(false);
  };

  const handleToggle = (cookieType) => {
    setConsent((prevState) => ({
      ...prevState,
      [cookieType]: !prevState[cookieType],
    }));
  };

  const saveSettings = () => {
    setShowSettings(!showSettings);
    if (showSettings) {
      localStorage.setItem("cookieConsent", JSON.stringify(consent));
      setIsVisible(false);
      setShowSettings(false);

      if (consent.analytics) {
        loadGoogleAnalytics();
      }

      if (consent.clarity) {
        loadClarity();
      }
    }
  };

  return (
    isVisible && (
      <div className="fixed bottom-0 right-0 left-0 md:left-auto md:right-0 md:bottom-0 rounded-lg bg-gray-800 shadow-lg z-50 p-4 md:p-6 text-white max-w-full md:max-w-md mx-auto md:mx-4 mb-4 md:mb-6 overflow-y-scroll">
        <h4 className="text-xl md:text-2xl text-leaderfy-500 mb-2 md:mb-4">
          Nutzung von Cookies: Wir benötigen Ihre Einwilligung.
        </h4>
        <p className="text-sm md:text-base mb-2 md:mb-4">
          Wir verwenden auf dieser Webseite Cookies. Diese verarbeiten auch
          personenbezogene Daten. Zum Einsatz kommen auf unserer Seite:
        </p>
        <ul className="list-disc pl-5 text-sm md:text-base mb-2 md:mb-4">
          <li>Technisch notwendige Cookies</li>
          <li>Statistik-Cookies</li>
          <li>Cookies von Drittanbietern</li>
        </ul>
        <p className="text-sm md:text-base mb-2 md:mb-4">
          Indem Sie auf „Cookie-Einstellungen“ klicken, erhalten Sie genauere
          Informationen zu unseren Cookies und können diese nach Ihren eigenen
          Bedürfnissen anpassen.
          <br />
          Durch einen Klick auf das Auswahlfeld „Alle akzeptieren“ stimmen Sie
          der Verwendung aller Cookies zu, die unter „Cookie-Einstellungen“
          beschrieben werden.
          <br />
          Sie können Ihre Einwilligung zur Nutzung von Cookies zu jeder Zeit
          ändern oder widerrufen.
        </p>
        {showSettings && (
          <div className="mb-2 md:mb-4">
            <h5 className="text-lg md:text-xl mb-1 md:mb-2">Cookie-Einstellungen</h5>
            <div className="flex flex-col space-y-1 md:space-y-2">
              <label className="flex items-center">
                <input
                  type="checkbox"
                  checked={consent.analytics}
                  onChange={() => handleToggle("analytics")}
                  className="form-checkbox"
                />
                <span className="ml-2 text-sm md:text-base">Statistik-Cookies (Google Analytics)</span>
              </label>
              <label className="flex items-center">
                <input
                  type="checkbox"
                  checked={consent.clarity}
                  onChange={() => handleToggle("clarity")}
                  className="form-checkbox"
                />
                <span className="ml-2 text-sm md:text-base">Microsoft Clarity</span>
              </label>
            </div>
          </div>
        )}
        <div className="flex flex-col space-y-2 md:space-y-4">
          <div className="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-4">
            <button
              onClick={handleConsent}
              className="w-full rounded-lg py-2 px-4 text-center text-sm font-medium text-white bg-leaderfy-500"
            >
              Alle Akzeptieren
            </button>
            <button
              onClick={handleDecline}
              className="w-full rounded-lg border py-2 px-4 text-center text-sm font-medium text-white border-gray-400 bg-gray-600"
            >
              Nur notwendige Cookies
            </button>
          </div>
          <button
            onClick={saveSettings}
            className="w-full rounded-lg py-2 px-4 text-center text-sm font-medium text-white bg-leaderfy-500"
          >
            {showSettings ? "Einstellungen speichern" : "Cookie-Einstellungen"}
          </button>
        </div>
      </div>
    )
  );
};

export default CookieConsent;